define([
	'internal_util/Util',
	'model/Image',
	'model/Origin',
	'model/AuthenticationOption'
], function (
		Util,
		Image,
		Origin,
		AuthenticationOption
		) {
	'use strict';

	/**
	 * AuthenticationOptionGroup class
	 */
	return function (id, authenticationOptions, description, image, attributes, requestedAttributes) {
		var _id,
				_authenticationOptions,
				_description,
				_image,
				_attributes,
				_requestedAttributes;
                
//                console.info(" == AuthenticationOptionGroup == ");
//                console.groupCollapsed("New AuthenticationOptionGroup -> ",id);
//                console.info("id: ",id);
//                console.info("description: ",description);
//                    console.groupCollapsed("authenticationOptions");
                    for (var d in authenticationOptions) {
//                        console.info(authenticationOptions[d].id());
                    }
//                    console.groupEnd();
//                console.groupEnd();

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			throw new Error('invalid authentication option group id: ' + id);
		}

		if (Util.isArray(authenticationOptions)) {
			_authenticationOptions = authenticationOptions;
		} else {
			throw new Error('invalid authentication option group options: ' + authenticationOptions);
		}

		if (Util.isValidString(description)) {
			_description = description;
		} else {
			throw new Error('invalid authentication option group description: ' + description);
		}

		if (image instanceof Image) {
			_image = image;
		} else {
			throw new Error('invalid authentication option group image: ' + image);
		}

		if (Util.isArray(attributes)) {
			_attributes = attributes;
		} else {
			_attributes = new Array();
		}

		if (Util.isArray(requestedAttributes)) {
			_requestedAttributes = requestedAttributes;
		} else {
			_requestedAttributes = new Array();
		}

		// overwrite requested attributes and UIInfo (description and image) of options to the values of the group
		_authenticationOptions = _authenticationOptions.map(function(option) {
			return new AuthenticationOption(
					option.id(),
					option.activation(),
					option.type(),
					option.protocol(),
					option.issuer(),
					_description,
					_image,
					option.attributes(),
					_requestedAttributes,
					option.derivedCredentials()
			);
		});

		// public methods

		this.id = function () {
			return _id;
		};

		this.authenticationOptions = function () {
			return _authenticationOptions;
		};

		this.activation = function () {
			// only authentication options with same activation type can be grouped
			return _authenticationOptions[0].activation();
		};

		this.cloudID = function () {
			// only authentication options with same activation type can be grouped
			return _authenticationOptions[0].cloudID();
		};

		this.description = function () {
			return _description;
		};

		this.image = function () {
			return _image;
		};

		this.attributes = function () {
			return _attributes;
		};

		this.requestedAttributes = function () {
			return _requestedAttributes;
		};

		this.matchesAuthenticationOption = function (authenticationOption) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].matchesAuthenticationOption(authenticationOption)) {
					return true;
				}
			}
			return false;
		};

		/**
		 * Check if the given AuthenticationOption Type equals one of the option's Types in this group.
		 * 
		 * @param {string} type AuthenticationOption Type.
		 * @returns {Boolean} true if given Type equals one of the option's Types in this group; false otherwise.
		 */
		this.matchesType = function (type) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].matchesType(type)) {
					return true;
				}
			}
			return false;
		};
		
		/**
		 * Check if the given CloudIdentity is valid and usable (w.r.t. requested attributes) for 
		 * one of the options in this group.
		 * 
		 * @param {CloudIdentity} identity CloudIdentity object.
		 * @returns {Boolean} true if check succeeds; false otherwise.
		 */
		this.matchesIdentity = function (identity) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].matchesIdentity(identity)) {
					return true;
				}
			}
			return false;
		};

		this.toObject = function () {
			return {
				id: _id,
				authenticationOptions: Util.serialize(_authenticationOptions),
				description: _description,
				image: Util.serialize(_image),
				attributes: Util.serialize(_attributes),
				requestedAttributes: Util.serialize(_requestedAttributes)
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/AuthenticationOptionGroup.js
// module id = 34
// module chunks = 3